import React, { useState, useEffect } from "react";
import ProvaAccordionSection from "../components/multitessere/ProvaAccordionSection";
import DueMultitessereSezioni from "../components/multitessere/DueMultitessereSezioni";
import foto1 from "../images/multitessere.png";
import Titolo from "../commons/Titolo";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import SpaceL from "../commons/SpaceL";
import AllertIscrizione from "../components/multitessere/AllertIscrizione";
import AccordionSmall from "../components/multitessere/AccordionSmall";
import CardInEvidenza from "../components/spa/CardInEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";
import barista from "../images/News/Barista.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";

function Multitessere() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto1} title={"MULTITESSERE"}/>
            <SpaceL />
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p style={{fontSize: "30px", padding:"1em", fontFamily: "Hammersmith One"}}>Scegli la formula di abbonamento più adatta a te </p>
                </blockquote>
            </figure>

            {windowWidth > 900 ? (
                <DueMultitessereSezioni />
            ) : (
                <AccordionSmall />
            )}
            <SpaceL />
            <AllertIscrizione />
            <Space />
            <div className="m-auto" style={{maxWidth: "90%"}}>
                <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                <hr/>
                <div className="d-none d-sm-block" >
                    <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardInEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"../news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                    </div>
                </div>
                <div className="d-sm-none  " >
                    <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>

                        <CardNewsEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"../news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                    </div>
                </div>

            </div>
            <Space />


        </div>
    );
}

export default Multitessere;
